import React, { useEffect, useState } from 'react'
import Layout from '../../../brands/components/Layout'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Personalinfo from './Personal-info'
import Jobinfo from './job-info'
import Timeoffinfo from './time-off-info'
import Trainingcompleted from './training-completed'
import Formscompleted from './forms-completed'
import './index.css'
import { useLocation } from 'react-router-dom'
import {
    getLookupValues,
    getLocations,
} from '../../../../features/userslisting/createuser/api'
import { useAppSelector, useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { PaginatedDataLocationLookup } from '../../type'
// import { useNavigate } from 'react-router-dom'

const Viewuser: React.FC = () => {
    const location = useLocation()
    const dispatch = useAppDispatch()
    const params = new URLSearchParams(location.search)
    const otherUserId = params.get('userId')
    const [lookupValues, setLookupValues] = useState<any>([])
    const [locationsLookupValues, setLocationsLookupValues] =
        useState<PaginatedDataLocationLookup | null>(null)
    const [userId, setUserId] = useState<string>('')
    const { role } = useAppSelector((state) => state.persistedReducers.user)
    const [activeTab, setActiveTab] = useState<string>('Personalinfo')
    const [userLeavePolicyId, setUserLeavePolicyId] = useState<string>('')

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const getLookUpData = async () => {
            try {
                const lookupValues = await getLookupValues()
                const locations = await getLocations()
                setLookupValues(lookupValues.data)
                setLocationsLookupValues(locations.data)
            } catch (err) {
                console.error('Error fetching:', err)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        getLookUpData()
    }, [])

    return (
        <div>
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>
                                    {location.pathname === '/profile'
                                        ? `View Profile`
                                        : 'View Employee/Manager Profile'}{' '}
                                </h4>
                            </div>
                        </div>
                        {location.pathname !== '/profile' && (
                            <div className="mt-2 prof-info">
                                <div className="row">
                                    <p>Jessica Jones</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="Personalinfo"
                    id="uncontrolled-tab-example"
                    className="mb-3 mt-4 custom-tabs"
                    onSelect={(k) => setActiveTab(k || 'Personalinfo')}
                >
                    <Tab eventKey="Personalinfo" title="Personal Info">
                        <Personalinfo
                            lookupValues={lookupValues}
                            locationsLookupValues={locationsLookupValues}
                            setUserId={setUserId}
                            isActive={activeTab === 'Personalinfo'}
                            setUserLeavePolicyId={setUserLeavePolicyId}
                        ></Personalinfo>
                    </Tab>
                    {(location.pathname === '/profile' ||
                        location.pathname === '/users/view') &&
                        role === 'Admin' && (
                            <Tab eventKey="profile" title="Job Info">
                                <Jobinfo
                                    lookupValues={lookupValues}
                                    userId={userId}
                                    isActive={activeTab === 'profile'}
                                />
                            </Tab>
                        )}

                    <Tab eventKey="contact1" title="Time Off Info">
                        <Timeoffinfo
                            otherUserId={otherUserId}
                            userId={userId}
                            isActive={activeTab === 'contact1'}
                            userLeavePolicyId={userLeavePolicyId}
                        ></Timeoffinfo>
                    </Tab>
                    <Tab eventKey="contact2" title="Trainings Completed">
                        <Trainingcompleted
                            otherUserId={otherUserId}
                            isActive={activeTab === 'contact2'}
                        ></Trainingcompleted>
                    </Tab>
                    <Tab eventKey="contact" title="Forms Completed">
                        <Formscompleted
                            otherUserId={otherUserId}
                            isActive={activeTab === 'contact'}
                        ></Formscompleted>
                    </Tab>
                </Tabs>
            </Layout>
        </div>
    )
}

export default Viewuser
